import NatsProvider from '.'
import { WithChildren } from '@/root/types/utilities'

const NatsProviderWrapper = ({
  children,
  platform,
  authorization,
}: WithChildren<{ platform?: string; authorization?: string }>) => {
  return (
    <NatsProvider platform={platform} authorization={authorization}>
      {children}
    </NatsProvider>
  )
}

export default NatsProviderWrapper
